export const removeTags = (str: string) => {
  if (str === undefined || str === null || str === '') return ''
  else str = str.toString()

  str = str.split('&nbsp;').join('')
  return str.replace(/(<([^>]+)>)/gi, '')
}
